<!-- use helpTooltip component instead -->
<template>
  <div ref="tooltipContainer" :class="tooltipClass">
    <button type="button" class="tooltip-btn" :class="[buttonColor]" data-toggle="tooltip" :title="helpText" >
      <icon class="help" aria-hidden="true"></icon>
    </button>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import bootstrapToolTip from "~/components/bootstrapTooltip"


  export default Vue.extend({
    data: function () {
      return {
        bootstrapToolTip: new bootstrapToolTip(),
      };
    },
    props: {
      text: {
        type: String,
        default: null
      },
      inline: {
        type: Boolean,
        default: false
      },
      buttonColor: {
        type: String,
        default: 'grey'
      }
    },
    mounted() {
      this.bootstrapToolTip.init($(this.$refs.tooltipContainer))
    },
    computed: {
      helpText(): string {
        return this.text
      },
      tooltipClass() {
        return {
          'inline-tooltip': this.inline,
          'inline': this.inline
        }
      }
    }
  });
</script>